const mockExpense = [
  { name: 'Food', icon: '/assets/icons/category/food.svg' },
  { name: 'Transportation', icon: '/assets/icons/category/car.svg' },
  { name: 'Rentals', icon: '/assets/icons/category/cabin-svgrepo-com.svg' },
  { name: 'Water Bill', icon: '/assets/icons/category/water-svgrepo-com.svg' },
  { name: 'Phone Bill', icon: '/assets/icons/category/mobile-phone-svgrepo-com.svg' },
  { name: 'Electricity Bill', icon: '/assets/icons/category/electricity-thunder-svgrepo-com.svg' },
  { name: 'Gas Bill', icon: '/assets/icons/category/gas-svgrepo-com.svg' },
  { name: 'Television Bill', icon: '/assets/icons/category/television-svgrepo-com.svg' },
  { name: 'Internet Bill', icon: '/assets/icons/category/internet-svgrepo-com.svg' },
  { name: 'Other Utility Bills', icon: '/assets/icons/category/three-circles-of-different-sizes-one-inside-other-svgrepo-com.svg' },
  { name: 'House Maintenance', icon: '/assets/icons/category/house-svgrepo-com.svg' },
  { name: 'Vehicle Maintenance', icon: '/assets/icons/category/automobile-vehicle-svgrepo-com.svg' },
  { name: 'Medical Check Up', icon: '/assets/icons/category/medical-kit-svgrepo-com.svg' },
  { name: 'Education', icon: '/assets/icons/category/education-svgrepo-com.svg' },
  { name: 'Persional items', icon: '/assets/icons/category/person-or-personal-synchronization-circular-symbol-svgrepo-com.svg' },
  { name: 'Pets', icon: '/assets/icons/category/dog-face-svgrepo-com.svg' },
  { name: 'Fitness', icon: '/assets/icons/category/fitness-centre-svgrepo-com.svg' },
  { name: 'Makeup', icon: '/assets/icons/category/makeup-svgrepo-com.svg' },
  { name: 'Gifts & Donations', icon: '/assets/icons/category/donation-svgrepo-com.svg' },
  { name: 'Investment', icon: '/assets/icons/category/investment-svgrepo-com.svg' },
  { name: 'Other expense', icon: '/assets/icons/category/pay-svgrepo-com.svg' },
  { name: 'Salary', icon: '/assets/icons/category/money-svgrepo-com.svg' },
  { name: 'Income transfer', icon: '/assets/icons/category/transfer-svgrepo-com.svg' },
  { name: 'Other income', icon: '/assets/icons/category/profit-svgrepo-com.svg' }
];

export default mockExpense;
